import {
  FC,
  ReactElement,
  useEffect,
  useState,
  useRef
} from "react";
import { Card, CardHeader } from "../Form.Status/Status.styled";
import CloseIcon from "../../assets/CloseIcon.svg";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";
import { CardContainer, Label2, SavedCards } from "./MoveOut.styled";
import visa from "../../assets/visa.svg";
import CC from "../../assets/card2.svg";
import amex from "../../assets/amex.svg";
import { ButtonsContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import ccIcon from "../../assets/ccIcon.svg";
import cvv from "../../assets/cvv.svg";
import calendar from "../../assets/calendar.svg";
import { Frames, CardNumber, ExpiryDate, Cvv } from "frames-react";
import { toJS } from "mobx";
import { TabContainer, ThankyouHeader, ThankyouMessage } from "../SocialCaseTbas/Social.styled";
import CardsStore from "../../stores/CardsStore";
import General from "../../stores/GeneralStore";
import "./temp.css";
import { autorun } from "mobx";
import { observer } from "mobx-react";
import cardsStore from "../../stores/CardsStore";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import MoveInOut from "../../stores/MoveInOutStore";
import { Modal } from "@mui/material";
import { TRUE } from "sass";
import { Label } from "../../../src/screens/complaint/Complaint.styled";
interface Obj {
  [key: string]: any;
  fromAutoPay: any;
}

interface Props extends BaseProps {
  pKey?: string;
  paymentLoader?: Boolean;
  fromAutoPay: any;
  amount?: any;
  emailForm?: any;
  verified?: () => void;
  onClose?: React.MouseEventHandler<HTMLImageElement>;
  makePayment: ({
    token,
    cvv,
    type,
    paymentRequestType,
    email,
  }: {
    token: string;
    cvv?: string;
    type?: string;
    email?: string;
    paymentRequestType?: number;
  }) => void;
}

const CardsPopup: FC<Props> = ({
  pKey = "pk_sbox_x5mnr3fhoxv7tgnvnx2dbam3yit",
  onClose,
  verified,
  makePayment,
  fromAutoPay,
  amount,
  emailForm = false,
  paymentLoader
}: Props): ReactElement => {
  const [chosenCard, setChosenCard] = useState(null);
  const [cVVValue, setCVVValue] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [chooseCardScreen, setChooseCardScreen] = useState(true);
  const [loader, setLoader] = useState(false);
  const [chosenCardData, setChosenCardData] = useState<any>();
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [isTouched, setTouched] = useState(false);
  const emailRef = useRef("");
  const handleUseSavedCard = () => {
    //const card:Obj = cardsList[chosenCard]
    //check if selection made
    // setChooseCardScreen(false);
    const currentLAn = General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode === "ARA" ? 'ar' : General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode === "HIN" ? "hi" : 'en'
    makePayment({
      // cvv: cVVValue,
      type: `${currentLAn}-Payments-Web`,
      paymentRequestType: 2,
      token: chosenCardData?.token,
      email,
    });
  };

  const handleAddCard = () => {
    setChooseCardScreen(false);

    // const card:Obj = cardsList[chosenCard]

    // const data = {
    //   expiryMonth: card.expiryMonth,
    //   expiryYear: card.expiryYear,
    //   last4: card.last4,
    //   paymentMethod: card.paymentMethod
    // }
    // await addCard({errorId: 'addCardError', data})
  };

  const handleGetCardsList = async () => {
    await CardsStore.getCardsList({ errorId: "getCardsListError" });
  };
  const handlechange = (card: any, index: any) => {
    setChosenCard(index);
    const data = {
      token: card?.sourceId,
      type: card?.cardType,
      paymentRequestType: 2,
    }
    setChosenCardData(data)
  };

  useEffect(() => {
    handleGetCardsList();
  }, []);

  // const localStorageValue = JSON.parse(
  //   localStorage.getItem("settingUplanguage") || "en-US"
  // );

  // let typesValue =
  //   localStorageValue === "en-US"
  //     ? "en-Payments-Web"
  //     : localStorageValue === "ar"
  //     ? "ar-Payments-Web"
  //     : "hi-Payments-Web";
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  const HanldeAddNewCard = () => {
    setLoader(true)
    if (cVVValue !== '') {
      setLoader(true);
    }
    else {
      setLoader(false);
    }

  }
  const allowContnue = () => { 
    if (!emailForm) {
      return true
    }
      return email && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)

  }

  return (
    <div
      style={{
        direction: General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode === "ARA" ? "rtl" : "ltr",
        width: General?.isLargeScreen ? "35%" : "100%",
        height: "70%",
        margin: 'auto',
        position: "absolute",
        top: "45%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      {chooseCardScreen ? (
        <div
          // className="DynamicBgColor"
          style={{
            // height: '20%',
            width: "100%",
            justifyContent: "space-between",
            padding: "1rem",
            background: General.contrast.contrastBackground
              ? General.contrast.contrastBackground
              : General?.ColorAss,
            display: "flex",
            alignItems: "center",
          }}

        >
          <h1
            style={{
              color: General.contrast.contrastColor
                ? General.contrast.contrastColor
                : '#fff',
              justifySelf: "flex-start",
              fontSize: `${2 * General.accessibility.fontSize}rem`,
              textTransform: 'capitalize',
            }}
          >
            {fromAutoPay ? General?.codeLabels["cm_add_card"]?.label !== undefined ? General?.codeLabels["cm_add_card"]?.label : "Add New Card" : CardsStore?.list?.cards?.length > 0 ? General?.codeLabels["cm_saved_cards"]?.label !== undefined
              ? General?.codeLabels["cm_saved_cards"]?.label
              : "Saved Cards" : General?.codeLabels["cm_payment_due"]?.label !== undefined ? General?.codeLabels["cm_payment_due"]?.label : "payment dues"}
          </h1>
          <img style={{ cursor: 'pointer' }} src={CloseIcon} alt="" onClick={onClose} />
        </div>
      ) : (
        <div
          style={{
            background: General.contrast.contrastBackground
              ? General.contrast.contrastBackground
              : General?.ColorAss,
            height: "70px",
            width: "100%",
          }}
        >
          <p
            style={{
              color: General.contrast.contrastColor
                ? General.contrast.contrastColor
                : '#fff',
              fontSize: `${1.875 * General.accessibility.fontSize}rem`,
              fontFamily: "Segoe UI",
              fontWeight: "400",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70px",
              width: General?.isLargeScreen ? "35%" : "100%",
              marginTop: "0px",
            }}
          >
            {fromAutoPay ? General?.codeLabels["cm_add_card"]?.label !== undefined ? General?.codeLabels["cm_add_card"]?.label : "Add New Card" : General?.codeLabels["cm_new_card_head"]?.label !== undefined ? General?.codeLabels["cm_new_card_head"]?.label : "New Card"}
          </p>
          {onClose && <img src={CloseIcon} alt="dsf" onClick={onClose} />}
        </div>

      )}

      <TabContainer
        style={{
          padding: "12px 0px",
          display: "flex",
          gap: "0rem",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: General.contrast.contrastColor
            ? General.contrast.contrastColor
            : '#fff',
          color: General.contrast.contrastBackground
            ? General.contrast.contrastColor
            : General?.ColorAss,
        }}
      >
        {!fromAutoPay &&
          chooseCardScreen &&
          CardsStore.list?.cards?.length > 0 ? (
          <div
            style={{
              width: General?.isLargeScreen ? "50%vw" : "100%",
              padding: "20px",
              paddingBottom: "10px",
            }}
          >
            {emailForm && (
              <>
                <Label
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    padding: "0px 20px ",
                    justifyContent: "space-between",
                  }}
                >
                  <span
                    style={{
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                    }}
                  >

                    {General?.codeLabels["cm_amttopay"]?.label !== undefined
                      ? General?.codeLabels["cm_amttopay"]?.label
                      : "Amount To Pay"}
                  </span>
                  <span style={{
                    color: contrast?.contrastBackground
                      ? contrast?.contrastBackground
                      : General?.ColorAss,
                  }}>
                    {`${General?.codeLabels["cm_mob_aed"]?.label !== undefined ? General?.codeLabels["cm_mob_aed"]?.label : "AED"} ${new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(amount))}`}</span>
                </Label>
                <Label style={{
                  padding: "0px 20px ", color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : General?.ColorAss,
                }}>
                  {General?.codeLabels['cm_demail'].label ? General?.codeLabels['cm_demail'].label : "Email Address"} *
                  <input
                    pattern="/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i"
                      value={email}
                      onMouseDown={() => { setTouched(true) }}
                      onChange={(e) => {
                        setInvalidEmail(false)
                     
                      if (!e.target?.value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i) && e.target?.value) {
                        setInvalidEmail(true)
                      }
                      setEmail(e.target.value);
                      MoveInOut.setEmail(e.target.value)
                    }} 
                    style={{
                      width: '100%', color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                      background: contrast?.contrastBackground ? contrast?.contrastBackground : '#fff',
                    }} />
                    {invalidEmail && <div style={{ color: "red" }}>{General?.codeLabels['cm_emailerr']?.label}</div>}
                    {!email && isTouched &&<div style={{ color: "red" }}>{"Email is required"}</div>}
                </Label>
              </>
            )}
            <p
              style={{
                fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                fontFamily: "Segoe UI",
                fontWeight: "400",
                color: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : General?.ColorAss,
              }}
            //className={General?.textClass}
            >
              {General?.codeLabels["cm_card_saved_info"]?.label ? General?.codeLabels["cm_card_saved_info"]?.label : "Would you like to use your previously saved cards for this payment? Select the card below or use new card to pay"}
            </p>

            <div style={{ height: "20rem", overflow: "auto" }}>
              {CardsStore?.list?.cards?.map((card: any, index: any) => {
                return (
                  <CardContainer
                    style={{
                      background: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : "#edf6f6",
                      marginBottom: "0.5rem",
                    }}
                    onClick={() => handlechange(card, index)}
                  >
                    <section
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1em",
                      }}
                    >
                      <Label2>
                        <input type="checkbox" checked={chosenCard === index}  style={{
                          backgroundColor: chosenCard === index ? "green" : "initial"
                          }}/>
                        <svg viewBox="0 0 21 18">
                          <symbol
                            id="tick-path"
                            viewBox="0 0 21 18"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.22003 7.26C5.72003 7.76 7.57 9.7 8.67 11.45C12.2 6.05 15.65 3.5 19.19 1.69"
                              fill="none"
                              strokeWidth="2.25"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </symbol>
                          <defs>
                            <mask id="tick">
                              <use className="tick mask" href="#tick-path" />
                            </mask>
                          </defs>
                          <use
                            className="tick"
                            href="#tick-path"
                            stroke=""
                          />
                          <path
                            fill="white"
                            mask="url(#tick)"
                            d="M18 9C18 10.4464 17.9036 11.8929 17.7589 13.1464C17.5179 15.6054 15.6054 17.5179 13.1625 17.7589C11.8929 17.9036 10.4464 18 9 18C7.55357 18 6.10714 17.9036 4.85357 17.7589C2.39464 17.5179 0.498214 15.6054 0.241071 13.1464C0.0964286 11.8929 0 10.4464 0 9C0 7.55357 0.0964286 6.10714 0.241071 4.8375C0.498214 2.39464 2.39464 0.482143 4.85357 0.241071C6.10714 0.0964286 7.55357 0 9 0C10.4464 0 11.8929 0.0964286 13.1625 0.241071C15.6054 0.482143 17.5179 2.39464 17.7589 4.8375C17.9036 6.10714 18 7.55357 18 9Z"
                          />
                        </svg>
                        <svg className="lines" viewBox="0 0 11 11">
                          <path d="M5.88086 5.89441L9.53504 4.26746" />
                          <path d="M5.5274 8.78838L9.45391 9.55161" />
                          <path d="M3.49371 4.22065L5.55387 0.79198" />
                        </svg>
                      </Label2>
                      <img src={visa} alt="" />
                    </section>
                    <div style={{ 
                      display: "flex", 
                      flexDirection: "row",
                      justifyContent: "flex-start", 
                      gap: "3rem",
                      width: "80%",
                      fontSize: `${General.accessibility.fontSize}rem`,
                    }}>
                      <div>
                      <span style={{
                        color: contrast?.contrastColor ? contrast?.contrastColor : "",
                        fontWeight: "bold",
                        display: "block"
                      }}>
                        {General?.codeLabels["cm_card_number"]?.label || "Card Number"}
                      </span>
                      <span style={{
                        color: contrast?.contrastColor ? contrast?.contrastColor : "",
                        marginTop: "4px"
                      }}>
                        {`XXXX XXXX XXXX ${card?.cardNumber}`}
                      </span>
                      </div>

                      <div>
                      <span style={{
                        color: contrast?.contrastColor ? contrast?.contrastColor : "",
                        fontWeight: "bold",
                        display: "block"  
                      }}>
                        {General?.codeLabels["cm_expiry_date"]?.label || "Expiry Date"}
                      </span>
                      <span style={{
                        color: contrast?.contrastColor ? contrast?.contrastColor : "",
                        marginTop: "4px"
                      }}>
                        {`${card?.expiryMonth} / ${card?.expiryYear}`}
                      </span>
                      </div>
                    </div>
                  </CardContainer>
                );
              })}
            </div>

            <ButtonsContainer style={{ width: "100%", marginTop: "1rem" }}>
              {!fromAutoPay && CardsStore?.list?.cards?.length > 0 ? (
                <ButtonSecondary
                  style={{
                    width: "45%",
                    padding: "auto",
                    color: General.contrast.contrastColor
                      ? General.contrast.contrastColor
                      : General?.ColorAss,
                    background: General.contrast.contrastBackground
                      ? General.contrast.contrastBackground
                      : "#fff",
                    fontSize: `${General.accessibility.fontSize}rem`,
                    opacity: !allowContnue() || !chosenCardData? '0.5' : '1',
                  }}
                  onClick={handleUseSavedCard}
                  className={General?.colorClass}
                  disabled={!chosenCardData || !allowContnue()}
                >
                  {paymentLoader ? <Spinner width="30px" height="30px" /> : General?.codeLabels["cm_btncontinue"]?.label !== undefined
                    ? General?.codeLabels["cm_btncontinue"]?.label
                    : "Continue"}
                </ButtonSecondary>
              ) : null}
              <ButtonSecondary
                style={{
                  width: "45%",
                  padding: "20px",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "",
                }}
                onClick={handleAddCard}
              >
                {General?.codeLabels["cm_card_use_new"]?.label ? General?.codeLabels["cm_card_use_new"]?.label : "USE NEW CARD"}
              </ButtonSecondary>
            </ButtonsContainer>
          </div>
        ) : (
          <Frames
            config={{
              debug: true,
              publicKey: pKey,
              style: {
                base: {
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  background: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#e5eff2",
                  height: "3.5rem",
                  paddingLeft: "5rem",
                },
                invalid: {
                  color: 'red',
                },
                },
               
            }}
            ready={() => { }}
            cardTokenized={(e) => {
              //TODO: IF ADDING A CARD, the add card api returns a redirect url, so bit kaffe fiya
              //hay hiyye li payment type addcard (most probably)



              //savecard
              if (fromAutoPay) {
                CardsStore.addCard({
                  expiryMonth: e["expiry_month"],
                  expiryYear: e["expiry_year"],
                  last4: e.last4,
                  paymentMethod: e.scheme ? e.scheme : "",
                  token: e.token,
                }).then((res) => { });
              }
              autorun(() => { });
              const currentLAn =
                General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode ===
                  "ARA"
                  ? "ar"
                  : General?.codeLabels["cm_pdc_paymentaccounts"]
                    ?.languageCode === "HIN"
                    ? "hi"
                    : "en";
              makePayment({
                // cvv: cVVValue,
                type: `${currentLAn}-Payments-Web`,
                paymentRequestType: 1,
                token: e.token,
                email:emailRef.current,
              });
            }}
          >
            <div
              style={{
                background: General.contrast.contrastColor
                  ? General.contrast.contrastColor
                  : "#fff",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: amount ? "" : "15rem",
                }}
              >
                {amount && (
                  <>
                    <Label
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        padding: "0px 20px ",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{
                        color: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : General?.ColorAss,
                      }}>
                        {General?.codeLabels["cm_amttopay"]?.label !== undefined
                          ? General?.codeLabels["cm_amttopay"]?.label
                          : "Amount To Pay"}
                      </span>
                      <span
                        style={{
                          color: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            : General?.ColorAss,
                        }}>
                        {`AED ${new Intl.NumberFormat('en', { minimumFractionDigits: 2 }).format(Number(amount))}`}
                      </span>
                    </Label>
                    {emailForm && <Label style={{
                      color: contrast?.contrastBackground
                        ? contrast?.contrastBackground
                        : General?.ColorAss,
                      padding: "0px 20px ",
                    }}>
                      {General?.codeLabels['cm_demail'].label ? General?.codeLabels['cm_demail'].label : "Email Address"}*
                      <input pattern="/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i" value={email} onChange={(e) => {
                        setInvalidEmail(false)
                        if (!e.target?.value.match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i) && e.target?.value) {
                          setInvalidEmail(true)
                        }
                        emailRef.current = e.target.value;
                        setEmail(e.target.value);
                        MoveInOut.setEmail(e.target.value)
                      }} style={{ width: '100%', color: contrast?.contrastColor ? contrast?.contrastColor : General?.ColorAss,
                            background: contrast?.contrastBackground ? contrast?.contrastBackground : '#fff'
                      }}
                      onMouseDown={() => { setTouched(true) }}
                        />
                      {invalidEmail &&
                        <div style={{ color: "red" }}>
                          {General?.codeLabels['cm_emailerr']?.label}
                          </div>}
                          {!email && isTouched &&<div style={{ color: "red" }}>{"Email is required"}</div>}

                    </Label>}
                  </>
                )}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    padding: "0px 20px",
                  }}
                >
                  <div style={{ color: '', height: '7rem' }} >
                    <p
                      style={{
                        fontSize: `${0.875 * General.accessibility.fontSize
                          }rem`,
                        fontFamily: "Segoe UI",
                        fontWeight: "700",
                        color: contrast?.contrastBackground
                          ? contrast?.contrastBackground
                          : General?.ColorAss,
                      }}

                    >
                      {General?.codeLabels["cm_card_creadit"]?.label ? General?.codeLabels["cm_card_creadit"]?.label : "Credit / Debit card number"}
                    </p>
                    <img
                      src={ccIcon}
                      style={{
                        position: "absolute",
                        height: "55px",
                        width: "70px",
                        padding: "15px",
                      }} alt="ccIcon"
                    />
                    <CardNumber />
                  </div>
                  <div style={{ display: "flex", width: "100%", height: '7rem' }} >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                      }}

                    >
                      <p
                        style={{
                          fontSize: `${0.875 * General.accessibility.fontSize
                            }rem`,
                          fontFamily: "Segoe UI",
                          color: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            : General?.ColorAss,
                          fontWeight: "700",
                        }}
                      >
                        {General?.codeLabels["cm_expiry_date"]?.label !==
                          undefined
                          ? General?.codeLabels["cm_expiry_date"]?.label
                          : "Expiry Date"}
                      </p>
                      <img
                        src={calendar}
                        style={{
                          position: "absolute",
                          height: "55px",
                          width: "35px",
                          bottom: "18%",
                          left: General?.codeLabels["cm_expiry_date"]?.languageCode === 'ARA' ? '15%' : '5%',
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            :ColorAss,
                        }} alt="calendar"
                      />
                      <ExpiryDate />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                      }}
                    >
                      <p
                        style={{
                          fontSize: `${0.875 * General.accessibility.fontSize
                            }rem`,
                          fontFamily: "Segoe UI",
                          color: contrast?.contrastBackground
                            ? contrast?.contrastBackground
                            : General?.ColorAss,
                          fontWeight: "700",
                        }}
                      //className={General?.textClass}
                      >
                        {General?.codeLabels["cm_cvv_number"]?.label !==
                          undefined
                          ? General?.codeLabels["cm_cvv_number"]?.label
                          : "CVV Number"}
                      </p>
                      <img
                        src={cvv}
                        style={{
                          position: "absolute",
                          height: "55px",
                          width: "35px",
                          bottom: "18%",
                          left: "5%",
                          color: contrast?.contrastColor
                            ? contrast?.contrastColor
                            : "",
                        }} alt="cvv"
                      />
                      <Cvv
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          setCVVValue(e.currentTarget.value)
                        }
                        className="testCvv"
                      />
                    </div>

                  </div>
                  <div>

                  </div>

                </div>
              </div>
            </div>

            <ButtonSecondary
              onClick={() => {
                // HanldeAddNewCard();
                if (Frames?.isCardValid()) {
                  setLoader(true)
                  Frames.submitCard();

                }

              }}
              style={{
                color: contrast?.contrastBackground
                  ? contrast?.contrastColor
                  : "#fff",
                background: contrast?.contrastColor
                  ? contrast?.contrastBackground
                  : ColorAss,
                width: General?.isLargeScreen ? "92%" : "100%",
                marginLeft: General?.isLargeScreen ? "0px" : "0px",
                fontSize: `${General.accessibility.fontSize}rem`,
                border: "none",
                opacity: (emailForm && !allowContnue()) ? '0.5' : '1',
              }}
              disabled={emailForm ? !allowContnue() : false}
            >
              {loader ? (
                <Spinner width="30px" height="30px" />
              ) : fromAutoPay ? (
                General?.codeLabels["cm_add_card"]?.label !== undefined ? (
                  General?.codeLabels["cm_add_card"]?.label
                ) : (
                  "Add Card"
                )
              ) : General?.codeLabels["cm_paynow"]?.label !== undefined ? (
                General?.codeLabels["cm_paynow"]?.label
              ) : (
                "PAY NOW"
              )}
            </ButtonSecondary>
          </Frames>
        )}
      </TabContainer>
    </div>
  );
};

export default observer(CardsPopup);

